import React, { useState, useRef, useEffect, ReactNode } from 'react';
import { ArrowDownIcon } from './Icons/ArrowDownIcon';
import { ArrowUpIcon } from './Icons/ArrowUpIcon';

interface MySelectProps {
  options: { value: any; label: string | ReactNode }[];
  value?: any; 
  label?: string; 
  onChange?: (value: any) => void; // Az onChange prop opcionális, ami a kiválasztott értéket fogja kezelni
}

const MySelect: React.FunctionComponent<MySelectProps> = ({ 
  options,  
  value,
  label = "please choose..",
  onChange
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Kiválasztott érték inicializálása
  const [selectedValue, setSelectedValue] = useState<{ value: any; label: string | ReactNode } | null>(() => {
    if (value) {
      const defaultOption = options.find(option => option.value === value);
      return defaultOption || null;
    }
    return null;
  });

  const dropdownRef = useRef<HTMLDivElement>(null);

  // Dropdown megnyitása/zárása
  const toggleDropdown = () => {
    setIsOpen((prevState) => !prevState);
  };

  // Ha egy opciót választanak
  const handleOptionClick = (option: { value: any; label: string | ReactNode }) => {
    setSelectedValue(option);
    setIsOpen(false);

    // Ha van onChange callback, meghívjuk azt a kiválasztott értékkel
    if (onChange) {
      onChange(option.value);
    }
  };

  // Kattintás kívülről, ami bezárja a dropdown-t
  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={`myselect ${isOpen ? "myselect--opened" : ""}`} ref={dropdownRef}>
      <div className="myselect__input input-field" onClick={toggleDropdown}>
        {selectedValue ? (
          selectedValue.label
        ) : (
          label
        )}
        <div className="myselect__icon">
          {isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}
        </div>
        
      </div>
      {isOpen && (
        <ul className="myselect__options">
          {options.map((option) => (
            <li
              key={option.value}
              className="myselect__option"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MySelect;
